"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BadgeRef", {
  enumerable: true,
  get: function get() {
    return _types.BadgeRef;
  }
});
Object.defineProperty(exports, "BadgeProps", {
  enumerable: true,
  get: function get() {
    return _types.BadgeProps;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _color = _interopRequireDefault(require("../../modifiers/color"));

var _constants = require("./constants");

var _commonUIColors = require("../../utils/commonUIColors");

var _utils = require("../../utils");

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var colorModifiers = (0, _utils.applyDynamicModifiers)('color', function (_ref) {
  var color = _ref.color;
  return (0, _styledComponents.css)(["", ""], color && color in _commonUIColors.commonUIColors && (0, _color.default)(_commonUIColors.commonUIColors[color]));
});

var getSizeStyles = function getSizeStyles(key) {
  return (0, _styledComponents.css)(_constants.sizeStyles[key] || '');
};

var sizeModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)({
  small: function small(_ref2) {
    var v = _ref2.variant;
    return getSizeStyles("small.".concat(v));
  },
  medium: function medium(_ref3) {
    var v = _ref3.variant;
    return getSizeStyles("medium.".concat(v));
  },
  large: function large(_ref4) {
    var v = _ref4.variant;
    return getSizeStyles("large.".concat(v));
  }
}, 'size');
var variantModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)({
  round: function round() {
    return (0, _styledComponents.css)({
      borderRadius: '50%'
    });
  },
  square: function square() {
    return (0, _styledComponents.css)({
      borderRadius: '2px'
    });
  }
}, 'variant'); // The default coloring is explicitly set instead of relying on the
// `visualInterest.licoriceMousse.medium` colors. The "default" badge is
// intended to be used in “empty” and/or “no results” messages, the snowWhite
// fg color and lower contrast help convey “emptiness”.

var BadgeContainer = _styledComponents.default.div.withConfig({
  displayName: "Badge__BadgeContainer",
  componentId: "sc-1y6oxgp-0"
})(["align-items:center;display:inline-flex;justify-content:center;", ";", ";", ";", ";"], (0, _color.default)(_commonUIColors.commonUIColors.information), colorModifiers, sizeModifiers, variantModifiers);

function Badge(props, containerRef) {
  var ariaLabel = props['aria-label'],
      Icon = props.icon,
      size = props.size,
      rest = _objectWithoutProperties(props, ["aria-label", "icon", "size"]);

  return _react.default.createElement(BadgeContainer, _extends({
    ref: containerRef,
    size: size
  }, rest), _react.default.createElement(Icon, {
    size: size,
    role: "img",
    "aria-label": ariaLabel
  }));
}

var BadgeWithRef = (0, _react.forwardRef)(Badge); // @ts-ignore

BadgeWithRef.propTypes = _types.propTypes; // @ts-ignore

BadgeWithRef.defaultProps = _types.defaultProps;
BadgeWithRef.displayName = 'Badge';
var _default = BadgeWithRef;
exports.default = _default;